import { styled as muiStyled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';
import { abyssColors, white } from '@/theme/colors';
const imageCardBorderRadius = 5;

export const ImageThumbailContainer = muiStyled(Box)(() => ({
  position: 'relative',
  borderRadius: imageCardBorderRadius,
  minHeight: '276px',
  marginBottom: 10,
  backgroundColor: abyssColors.neutral[100],
  cursor: 'pointer',
}));

export const ImageThumbnailImgLoader = muiStyled(Box)(() => ({
  marginHorizontal: 'auto',
  textAlign: 'center',
  paddingTop: '25%',
}));

export const ImageThumbnailText = muiStyled(Box)(() => ({
  position: 'absolute',
  right: 5,
  bottom: 10,
  backgroundColor: abyssColors.neutral[800],
  padding: 9,
  opacity: 0.7,
  borderRadius: imageCardBorderRadius,
}));

export const ImageThumbnailActionButtons = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  mt: 3,
  position: 'sticky',
  bottom: 0,
  width: '100%',
  backgroundColor: white,
  padding: '10px',
  borderTop: '1px solid #ccc',
}));

export const ActionButton = muiStyled(Button)(() => ({
  width: '40%',
}));

export const ImageThumbnailHeader = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 10,
  position: 'sticky',
  top: 1,
  width: '100%',
  backgroundColor: white,
  marginLeft: 5,
}));

export const ImageFallback = muiStyled(Box)(() => ({
  paddingTop: '30%',
  textAlign: 'center',
}));
